/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './us';
import './common';
import '../common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboarding": {
        "nested": {
          "business": {
            "nested": {
              "BicPredictResponse": {
                "fields": {
                  "businessCategory": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "businessSubCategory": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "businessName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "businessType": {
                    "type": "squareup.onboarding.business.UsBusiness.Type",
                    "id": 4,
                    "rule": "optional"
                  },
                  "businessPhone": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "businessSize": {
                    "type": "squareup.onboarding.business.common.BusinessSize",
                    "id": 6,
                    "rule": "optional"
                  },
                  "estimatedAnnualRevenue": {
                    "type": "squareup.onboarding.business.common.EstimatedAnnualRevenue",
                    "id": 7,
                    "rule": "optional"
                  },
                  "city": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "state": {
                    "type": "squareup.onboarding.business.UsState",
                    "id": 9,
                    "rule": "optional"
                  },
                  "error": {
                    "type": "squareup.onboarding.common.Error",
                    "id": 10,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.BicPredictResponse) {
  $root.addJSON(jsonData);
}

/**
 * BIC = Business Information Collector
 *
 * SOURCE BicPredictResponse @ squareup/onboarding/business/bic.proto at 13:1
 */
export const BicPredictResponse = $root.lookupType('squareup.onboarding.business.BicPredictResponse');
fixType(BicPredictResponse);
Builder.createAndAttachToType(BicPredictResponse);